module.exports = __webpack_public_path__ + "static/media/Rubik-Medium.c513dc38.eot";